import React, { useEffect } from "react";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import LENSA from "../../assets/img/setsis.png";
import { Helmet } from "react-helmet";

const Aboutus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="">
      <Helmet>
        <title>Hakkımızda - LENSA</title>
        <meta
          name="description"
          content="Hakkımızda sayfamızdan bizim hakkımızda bilgi alabilirsiniz."
        />
      </Helmet>
      <CustomBanner title="Hakkımızda" breadTitle="Hakkımızda" image={Banner} />
      <div className="py-20 max-md:pb-20">
        <div className="container">
          <div className="flex items-center gap-16 max-md:flex-col">
            <div className="flex-1">
              <p className="text-5xl font-semibold mb-2">LENSA Grup</p>
              <p className="font-semibold text-lg">
                OT/VT (Otomatik Tanıma / Veri Toplama) alanında, Türkiye’nin
                önde gelen bilgi teknolojileri, yazılım, donanım firması olmayı
                hedeflemiş, bu yolda artan tecrübesi ve uzman kadrosuyla emin
                adımlarla yoluna devam etmektedir. LENSA, barkod teknolojileri,
                otomatik etiketleme makinaları, RFID donanımları ve özel yazılım
                çözümleri ile müşterilerine gerekli olan çözümü sunmaktadır.
                Tedarik etmiş olduğu tüm ürünlere teknik servis, yedek parça ve
                sarf malzemeleri de sağlayan firmamız, müşteri odaklı hizmet
                anlayışı ve Türkiye’nin 81 ilinde yer alan güçlü bayi ağı ile
                kesintisiz hizmet vermektedir. Kurumsal iş ortaklarına
                operasyonlarını daha etkin yürütmelerini sağlayacak çözümler
                sunarak değer sağlamayı amaçlayan LENSA, yenilikçi yaklaşımı ve
                güçlü finansman altyapısıyla 10 markanın Türkiye
                distribütörlüğünü yaparak yoluna devam etmektedir. Markalarımız;
                Argox, Point Mobile, Hanasis, Posbank, Sewoo, Spenta, Advantech,
                HID, Bluebird, Aclas, Custom, Point Tab.
              </p>
            </div>
            <div className="flex-1">
              <img src={LENSA} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
